import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { ref: "root" }
const _hoisted_2 = {
  key: 0,
  id: "maintenance",
  class: "py-4 fixed top-0 left-0 bg-primary-900 w-full h-full text-white bg-black flex flex-col gap-4 p-8 items-center justify-center"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"w-full md:w-1/2 text text-center space-y-4\"><svg class=\"mx-auto\" xmlns=\"http://www.w3.org/2000/svg\" width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\"><circle cx=\"50\" cy=\"50\" r=\"40\" stroke=\"white\" stroke-width=\"5\" fill=\"transparent\" stroke-dasharray=\"0, 251.2\" id=\"circleDisconnected\"></circle><svg x=\"20\" y=\"20\" width=\"60\" height=\"60\" fill=\"#ffffff\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.33 3.274a3.5 3.5 0 0 1 4.254 4.963l10.709 10.71-1.414 1.414L8.169 9.65a3.502 3.502 0 0 1-4.962-4.255l2.237 2.237a1.5 1.5 0 1 0 2.121-2.121l-2.236-2.24.001.002Zm10.367 1.884 3.182-1.768 1.414 1.414-1.768 3.182-1.768.354-2.12 2.12-1.415-1.413 2.121-2.121.354-1.768ZM8.979 13.29l1.414 1.414-5.303 5.303a1 1 0 0 1-1.492-1.327l.078-.087 5.303-5.303Z\"></path></svg><animate xlink:href=\"#circleDisconnected\" attributeName=\"stroke-dasharray\" dur=\"1s\" from=\"0,251.2\" to=\"251.2,251.2\" begin=\"0s\" fill=\"freeze\"></animate><animate xlink:href=\"#maintenance\" attributeName=\"opacity\" dur=\"0.5s\" from=\"0\" to=\"1\" begin=\"0.5s\" fill=\"freeze\"></animate></svg><p class=\"text-2xl\">Web en mantenimiento</p><p>Estamos realizando tareas de mantenimiento en este momento.<br class=\"hidden md:block\"> Por favor, vuelva a intentar ingresar más tarde. </p></div>", 1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "mainPage"
}
const _hoisted_6 = {
  id: "logo",
  class: "h-full w-full md:w-fit flex gap-4 md:gap-8 justify-between md:justify-start items-center"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text-white uppercase font-black text-xs md:text-sm flex-none" }
const _hoisted_9 = {
  key: 2,
  id: "divider",
  class: "h-8 w-0 border-r border-zinc-800 hidden md:block"
}
const _hoisted_10 = {
  key: 3,
  id: "cinemaSelector",
  class: "h-full"
}
const _hoisted_11 = { class: "text-white uppercase font-black text-xs md:text-sm flex-none" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-4 h-4",
  src: "/assets/icons/arrow-down.svg",
  alt: "seleccionar cine"
}, null, -1)
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-5 h-5",
  src: "/assets/icons/facebook-brands.svg",
  alt: "facebook"
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-5 h-5",
  src: "/assets/icons/x-brands.svg",
  alt: "twitter"
}, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-5 h-5",
  src: "/assets/icons/instagram-brands.svg",
  alt: "instagram"
}, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "footerContainer p-10 flex flex-col md:flex-row gap-8 items-center justify-between" }
const _hoisted_23 = { class: "cinema-info flex flex-col gap-4 md:gap-8 items-center md:flex-row" }
const _hoisted_24 = { class: "logo-container" }
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  key: 1,
  class: "text-white text-xl font-bold"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", {
  id: "divider",
  class: "h-8 w-0 border-r border-zinc-800 hidden md:block"
}, null, -1)
const _hoisted_28 = { class: "location text-sm text-center md:text-left" }
const _hoisted_29 = { class: "text-white" }
const _hoisted_30 = { class: "text-white" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  id: "divider",
  class: "h-8 w-0 border-r border-zinc-800 hidden md:block"
}, null, -1)
const _hoisted_32 = { class: "social flex gap-4" }
const _hoisted_33 = ["href"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-5 h-5",
  src: "/assets/icons/facebook-brands.svg",
  alt: "facebook"
}, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = ["href"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-5 h-5",
  src: "/assets/icons/x-brands.svg",
  alt: "twitter"
}, null, -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = ["href"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-5 h-5",
  src: "/assets/icons/instagram-brands.svg",
  alt: "instagram"
}, null, -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/_createStaticVNode("<div class=\"developer flex gap-8 text-center text-white\"><div class=\"flex flex-col gap-2 items-center\"><span class=\"text-xs\">Desarrollado por</span><a href=\"https://adro.studio\" class=\"text-xl opacity-25\">adro.studio</a></div><div class=\"flex flex-col gap-2 items-center\"><span class=\"text-xs\">Powered by</span><img class=\"h-8\" src=\"/assets/img/logo_gaf.svg\" alt=\"\"></div></div>", 1)
const _hoisted_43 = { class: "version text-center text-white p-2 bg-black" }
const _hoisted_44 = { class: "text-xs" }
const _hoisted_45 = {
  key: 2,
  class: "loading h-screen flex items-center justify-center"
}
const _hoisted_46 = {
  key: 3,
  class: "update py-4 fixed top-0 left-0 bg-primary-900 w-full h-full text-white bg-black flex flex-col gap-4 p-8 items-center justify-center z-50"
}
const _hoisted_47 = { class: "text text-center space-y-8" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", null, "Actualizando...", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Aguarde un momento, por favor", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.maintenanceMode == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (!_ctx.loading && _ctx.maintenanceMode == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (!_ctx.$route.path.includes('/seleccionar-complejo'))
              ? (_openBlock(), _createBlock(_component_NavBar, {
                  key: 0,
                  class: "fixed w-full top-0 left-0 z-10 bg-black"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      (_ctx.$store.state.cinemaInfo.logo)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: "/",
                            class: "logo h-8"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                id: "cinemaLogo",
                                src: _ctx.$store.state.cinemaInfo.logo,
                                alt: "Logo",
                                class: "h-full"
                              }, null, 8, _hoisted_7)
                            ]),
                            _: 1
                          }))
                        : (_ctx.$store.state.cinemas.length < 2)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 1,
                              to: "/"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$store.state.cinemaInfo.nombre), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                      (_ctx.$store.state.cinemaInfo.logo && _ctx.$store.state.cinemas.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                        : _createCommentVNode("", true),
                      (_ctx.$store.state.cinemas.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createVNode(_component_router_link, {
                              to: "/seleccionar-complejo",
                              class: "h-full flex gap-2 items-center"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$store.state.cinemaInfo.nombre), 1),
                                _hoisted_12
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["social", _ctx.$store.state.cinemas.length > 1 ? 'hidden md:flex md:gap-4 md:flex-none' : 'flex gap-4 flex-none'])
                    }, [
                      (_ctx.$store.state.cinemaInfo.facebook)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: _ctx.$store.state.cinemaInfo.facebook
                          }, _hoisted_15, 8, _hoisted_13))
                        : _createCommentVNode("", true),
                      (_ctx.$store.state.cinemaInfo.twitter)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: _ctx.$store.state.cinemaInfo.twitter
                          }, _hoisted_18, 8, _hoisted_16))
                        : _createCommentVNode("", true),
                      (_ctx.$store.state.cinemaInfo.instagram)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            href: _ctx.$store.state.cinemaInfo.instagram
                          }, _hoisted_21, 8, _hoisted_19))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("main", {
              class: _normalizeClass(["text-white min-h-[100dvh]", !_ctx.$route.path.includes('/seleccionar-complejo') ? 'pt-20' : ''])
            }, [
              _createVNode(_component_router_view, {
                onGetCinemaInfo: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getCinemaInfo($event)))
              }, {
                default: _withCtx(({ Component }) => [
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 1
              })
            ], 2),
            (!_ctx.$store.state.kioskMode)
              ? (_openBlock(), _createElementBlock("section", {
                  key: 1,
                  class: _normalizeClass(["footer bg-neutral-900", _ctx.$route.path.includes('carrito') || _ctx.$route.path == '/seleccionar-complejo' ? 'hidden' : 'block'])
                }, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        (_ctx.$store.state.cinemaInfo.logo)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.$store.state.cinemaInfo.logo,
                              alt: "Logo",
                              class: "h-8"
                            }, null, 8, _hoisted_25))
                          : (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.$store.state.cinemaInfo.nombre), 1))
                      ]),
                      _hoisted_27,
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$store.state.cinemaInfo.direccion), 1),
                        _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$store.state.cinemaInfo.localidad) + ", " + _toDisplayString(_ctx.$store.state.cinemaInfo.provincia), 1)
                      ]),
                      _hoisted_31,
                      _createElementVNode("div", _hoisted_32, [
                        (_ctx.$store.state.cinemaInfo.facebook)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: _ctx.$store.state.cinemaInfo.facebook
                            }, _hoisted_35, 8, _hoisted_33))
                          : _createCommentVNode("", true),
                        (_ctx.$store.state.cinemaInfo.twitter)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              href: _ctx.$store.state.cinemaInfo.twitter
                            }, _hoisted_38, 8, _hoisted_36))
                          : _createCommentVNode("", true),
                        (_ctx.$store.state.cinemaInfo.instagram)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 2,
                              href: _ctx.$store.state.cinemaInfo.instagram
                            }, _hoisted_41, 8, _hoisted_39))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _hoisted_42
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("p", _hoisted_44, "v" + _toDisplayString(_ctx.$store.state.webAppVersion), 1)
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_45, [
            _createVNode(_component_Spinner)
          ])),
    (_ctx.updateExists)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_Spinner, { class: "relative" }),
            _hoisted_48,
            _hoisted_49
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Toast, { ref: "toast" }, null, 512)
  ], 512))
}